import { configureStore, createSlice } from "@reduxjs/toolkit";

const uiSlice = createSlice({
  name: "ui",
  initialState: {
    isOpened: false,
  },
  reducers: {
    setIsOpened: (state, action) => {
      state.isOpened = action.payload;
    },
    // toggleIsOpened: (state) => {
    //   state.isOpened = !state.isOpened;
    // },
  },
});

// actions
export const { setIsOpened, toggleIsOpened } = uiSlice.actions;

// store
export const store = configureStore({
  reducer: {
    ui: uiSlice.reducer,
  },
});

// selector
export const selectIsOpened = (state) => state.ui.isOpened;

export default store;
